import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-20 md:py-32 px-4" data-id="element-173">
      <div className="max-w-4xl mx-auto" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-serif text-[#3A3A3A] leading-tight" data-id="element-176">
            El problema no es el desorden. Es lo que el desorden te hace sentir.
          </h2>

          <div className="prose prose-lg max-w-none text-[#5A5A5A] space-y-6" data-id="element-177">
            <p className="text-xl leading-relaxed" data-id="element-178">
              Hay un tipo de cansancio que no viene del trabajo. Viene de mirar
              tu casa y sentir que te está dejando tareas en la mente.
            </p>

            <p className="leading-relaxed" data-id="element-179">
              La encimera con cosas. La ropa que "solo la dejaste ahí un
              segundo". La entrada que se vuelve un depósito.
            </p>

            <p className="leading-relaxed" data-id="element-180">
              Y tú, tratando de descansar… mientras tu cerebro sigue haciendo
              inventario.
            </p>

            <div className="bg-[#F5F1E8] p-8 rounded-xl my-8" data-id="element-181">
              <p className="text-lg font-medium text-[#3A3A3A] mb-4" data-id="element-182">
                Ese ruido mental de fondo que no se calla, incluso cuando te
                sientas.
              </p>
              <p className="text-[#5A5A5A]" data-id="element-183">
                Porque cada cosa fuera de lugar se convierte en:
              </p>
              <ul className="mt-4 space-y-2 text-[#5A5A5A]" data-id="element-184">
                <li data-id="element-185">"lo tengo que hacer"</li>
                <li data-id="element-186">"no puedo con todo"</li>
                <li data-id="element-187">
                  "¿por qué no soy como esas personas que sí mantienen su casa?"
                </li>
              </ul>
            </div>

            <p className="leading-relaxed" data-id="element-188">
              No es que no limpies. Es que el sistema que estás usando te obliga
              a hacerlo en modo maratón.
            </p>

            <p className="text-xl font-medium text-[#3A3A3A] leading-relaxed" data-id="element-189">
              Y una mujer cansada no necesita más disciplina. Necesita un método
              que funcione cuando no tiene ganas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}